import { OptimizelyDecideOption } from '@optimizely/react-sdk';

export const FLAG = {
  DEALER_RATINGS_CONSISTENCY_EXPERIMENT: 'dealer_ratings_consistency_experiment',
  DEALER_RATINGS_MEASURING_EXPERIMENT: 'dealer_ratings_measuring_experiment',
  INCODE_KEEPER_AUTHORIZATION: 'incode_keeper_authorization',
  MW_0_2_GET_THE_APP_BANNER: 'mw_0_2_get_the_app_banner',
  MW_4_1_MILEAGE_REMOVAL: 'mw_4_1_mileage_removal',
  MW_4_5_ESTIMATED_SALE_PRICE_REMOVAL: 'mw_4_5_estimated_sale_price_removal',
  MW_5_2_HOME_FINANCE_MESSAGE: 'mw_5_2_home_finance_message',
  MW_8_3_SOCIAL_PROOF_MESSAGE: 'mw_8_3_social_proof_message',
  MW_14_2_REORDER_PAAS_WEB_ON_RAMP: 'mw_14_2_reorder_paas_web_on_ramp',
  MW_HIDE_NON_ELIGIBLE_SIGNUP_FORM: 'mw_hide_non-eligible_signup_form',
  PAAS_WEB_ON_RAMP: 'paas_web_on_ramp',
} as const;

export const EVENT = {
  AGENT_SUPPORT_CONTACTED: 'agent_support_contacted',
  ENQUIRY_CREATED: 'enquiry_created',
  ENQUIRY_LOADED: 'enquiry_load',
  EXPIRED_LINK_LOAD: 'expired_link_load',
  GET_THE_APP_BANNER_CLICKED: 'get_app_banner_clicked',
  GET_THE_APP_BANNER_HIDDEN: 'get_app_banner_hidden',
  HERO_MILEAGE_CTA_CLICKED: 'valuations_hero_mileage_cta_clicked',
  HERO_VRM_CTA_CLICKED: 'valuations_hero_vrm_cta_clicked',
  NON_MARKETPLACE_VALUATION_CTA_CLICKED: 'non_marketplace_valuation_cta_clicked',
  NON_MARKETPLACE_VALUATION_JOURNEY: 'non_marketplace_valuation_journey',
  OFFER_SELECT: 'offer_select',
  PERSONAL_DETAILS_UPDATED: 'personal_details_updated',
  PHOTO_HANDOVER_SEEN: 'photo_handover_seen',
  PROFILE_FIRST_QUESTION_ANSWERED: 'profile_first_question_answered',
  PROFILE_FIRST_QUESTION_SEEN: 'profile_first_question_seen',
  PS_ACCEPT_OFFER_CTA_CLICKED: 'ps_accept_offer_cta_clicked',
  PS_COMPLETE_SALE_CTA_CLICKED: 'ps_complete_sale_cta_clicked',
  SIGN_IN_CTA_CLICKED: 'sign_in_cta_clicked',
  SIGN_IN_LOADED: 'sign_in_load',
  SIGN_IN_SUCCESS_LOAD: 'sign_in_success_load',
  SIGN_UP_CTA_CLICKED: 'sign_up_cta_clicked',
  SIGN_UP_LOADED: 'sign_up_load',
  SIGN_UP_TOOLTIP_SHOW: 'contact_details_page_info_hover',
  SMV_MILEAGE_CTA_CLICKED: 'smv_mileage_cta_clicked',
  VALUATIONS_LOADED: 'valuations_load',
  VALUATIONS_MILEAGE_CTA_CLICKED: 'valuations_mileage_cta_clicked',
  VALUATIONS_MILEAGE_UPDATED: 'valuations_mileage_updated',
  VEHICLE_HUB_VIEW_SECTIONS: 'vehicle_hub_view_sections',
  VEHICLE_HUB_VIEW_VEHICLE_INFORMATION: 'vehicle_hub_view_vehicle_information',
} as const;

export const EXPERIMENT_DECISIONS_HEADER = 'experiment-decisions';

export const EXPERIMENT_RULE_KEYS = {
  DEALER_RATINGS_MEASURING_EXPERIMENT: {
    AA_TEST_ROLLOUT: 'dealer_ratings_measuring_experiment_aa_test_rollout',
    AB_TEST_ROLLOUT: 'dealer_ratings_measuring_experiment_ab_test_rollout',
  },
} as const;

export const DISABLE_DECISION = [OptimizelyDecideOption.DISABLE_DECISION_EVENT];
